import { j as e } from "../../jsx-runtime-82a9ddf6.js";
import { AlertIcon as i } from "../icons/icons/AlertIcon.js";
import { cva as c, cn as p } from "../../lib/cn.js";
const x = c(
  "relative flex flex-col items-start border-2 md:max-w-screen-md max-w-screen-md md:py-4 md:leading-5",
  {
    variants: {
      variant: {
        red: "border-rose-600 dark:bg-rose-600/10 bg-rose-600/10 dark:text-rose-600 text-rose-900",
        yellow: "border-amber-600 dark:bg-amber-600/10 bg-amber-600/10 dark:text-amber-600 text-amber-900",
        blue: "border-cyan-600 dark:bg-cyan-600/10 bg-cyan-600/10 dark:text-cyan-600 text-cyan-900",
        purple: "border-purple-600 dark:bg-purple-600/10 bg-purple-600/10 dark:text-purple-600 text-purple-900"
      },
      size: {
        small: "text-sm leading-4 p-3 rounded-md",
        medium: "text-base leading-5 p-4 rounded-lg",
        large: "text-base leading-6 p-6 rounded-lg"
      }
    },
    defaultVariants: {
      variant: "yellow",
      size: "medium"
    }
  }
), f = ({ show: s = !0, className: d = "", variant: l, title: a, children: n, size: r }) => {
  if (!s)
    return null;
  const m = x({ variant: l, size: r }), t = r === "small" ? 18 : r === "medium" ? 22 : 24, o = p(m, d);
  return /* @__PURE__ */ e.jsxs("div", { className: o, children: [
    a && /* @__PURE__ */ e.jsxs("div", { className: "flex items-center justify-center leading-3 gap-2 font-bold mb-1", children: [
      /* @__PURE__ */ e.jsx(i, { width: t, height: t }),
      /* @__PURE__ */ e.jsx("span", { children: a })
    ] }),
    /* @__PURE__ */ e.jsx("span", { children: n })
  ] });
};
export {
  f as Alert
};
